import { gql, useQuery } from "@apollo/client";

export type BillingPortalLinkResponse = {
  billingPortalLink: {
    link: string;
  };
};

const PaymentLinkQuery = gql`
  query billingPortalLink {
    billingPortalLink {
      link
    }
  }
`;

export const useBillingPortalLinkQuery = (options?: {
  skip?: boolean;
}) =>
  useQuery<BillingPortalLinkResponse>(PaymentLinkQuery, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "cache-first",
    ...options,
  });
